<template>
  <button-dialog-container
    :btn-icon="icon"
    :only-icon="true"
    :width-dialog="400"
    :size="getSize"
    :dialog-viewer.sync="dialog"
    :no-tool-tip="noToolTip"
    :title-tool-tip="tooltip"
    :title-dialog="$t('project.duration-label-instruction')"
    @ok-pushed="saveDuration"
  >
    <v-container class="mt-6 mb-8">
      <vue-timepicker
        id="timepicker"
        v-model="computedDuration"
        format="HH:mm:ss"
        fixed-dropdown-button
        hide-clear-button
        manual-input
      />
    </v-container>
  </button-dialog-container>
</template>

<script>
// External components
import vueTimepicker from "vue2-timepicker";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";

// Libs
const moment = require("moment");

// Connectors
import { ScheduleConnector } from "../Database/ScheduleConnector";

export default {
  components: {
    buttonDialogContainer,
    vueTimepicker,
  },
  props: {
    schedule: {
      type: Object,
      default: () => {},
    },
    getSize: {
      type: Number,
      default: 25,
    },
    icon: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    toolName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      duration: 0,
      dialog: false,
      durationError: false,
      durationErrorMessage: "",
    };
  },
  computed: {
    tooltip() {
      return this.schedule.duration + " " + this.$t("units.seconds");
    },
    computedDuration: {
      get() {
        const formatted = moment.utc(this.duration * 1000).format("HH:mm:ss");
        return formatted;
      },
      set(value) {
        const secs = moment(value, "HH:mm:ss").diff(moment().startOf("day"), "seconds");

        if (secs < 1) {
          this.durationErrorMessage = this.$t("field.min-duration");
          this.durationError = true;
          return;
        } else if (secs > 86400) {
          this.durationErrorMessage = this.$t("field.max-duration");
          this.durationError = true;
          return;
        }

        this.durationErrorMessage = "";
        this.durationError = false;

        this.duration = secs;
      },
    },
  },
  mounted() {
    this.duration = this.schedule.duration;
  },
  methods: {
    saveDuration() {
      const promises = this.schedule.projectData.group.map((group) => {
        return this.scheduleConnector.updateSchedulePlayerDuration(group.id_sched, group.plyr_id, this.duration);
      });

      Promise.all(promises)
        .then(() => {
          this.schedule.duration = this.duration;
        })
        .catch((err) => {
          console.error("Error on update schedule duration :", err);
        });
    },
  },
};
</script>

<style>
#timepicker {
  width: 140px;
}
</style>
